/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `LOADING` - Loading
* `BOL_ISSUE_DATE` - BoL issue date
* `PORT_DEPARTURE` - Port departure
* `PORT_ARRIVAL` - Port arrival
* `SITE_DELIVERY` - Site delivery
 */
export type FixingDateEvent = typeof FixingDateEvent[keyof typeof FixingDateEvent];


export const FixingDateEvent = {
  LOADING: 'LOADING',
  BOL_ISSUE_DATE: 'BOL_ISSUE_DATE',
  PORT_DEPARTURE: 'PORT_DEPARTURE',
  PORT_ARRIVAL: 'PORT_ARRIVAL',
  SITE_DELIVERY: 'SITE_DELIVERY',
} as const;
